import React from 'react'


export default function CustomToolbarSelectWrapper({ children }) {
	return <div className="CustomToolbarSelectWrapper">
        { children }
	</div>
}